import { Validators, FormForType, formFor } from "fw-model";
const { required } = Validators;

import { EmailContact } from "models/email-contact";

export type EmailContactFormType = FormForType<EmailContact>;

export const emailContactFormCreator = (addressRequired = false, nameRequired = false) => {
  return formFor(EmailContact, s => {
    s.field(u => u.Address, "Email Address", v => {
      if (addressRequired) v.use(required);
      else v.if(u => u.Name != null && u.Name.length > 0, required);
    });
    s.field(u => u.Name, "Name", v => {
      if (nameRequired) v.use(required);
    });
  });
};
